__turbopack_context__.v({
  "content": "icon-3d-hover-module__LBRFBa__content",
  "descriptionText": "icon-3d-hover-module__LBRFBa__descriptionText",
  "headingText": "icon-3d-hover-module__LBRFBa__headingText",
  "iconContainer": "icon-3d-hover-module__LBRFBa__iconContainer",
  "iconHover3D": "icon-3d-hover-module__LBRFBa__iconHover3D",
  "iconHover3DWrapper": "icon-3d-hover-module__LBRFBa__iconHover3DWrapper",
  "textContainer": "icon-3d-hover-module__LBRFBa__textContainer",
});
